import React from 'react'

import Section from 'components/smartSearch/SidebarSection/SidebarSection'

import Link from '../Link/Link'

import s from './CategoryLinks.scss'


const SEOCategoryLinks = ({ pathname, gender }) => {
  let path
  let bestsellersTitle
  let newArrivalsTitle

  switch (pathname) {
    case '/perfumes':
      path = 'perfumes'
      bestsellersTitle = 'Best selling perfumes'
      newArrivalsTitle = 'New arrivals'
      break

    case '/colognes':
      path = 'colognes'
      bestsellersTitle = 'Best selling colognes'
      newArrivalsTitle = 'New arrivals'
      break

    case '/fragrance':
      path = 'fragrance'
      bestsellersTitle = 'Best selling fragrance'
      newArrivalsTitle = 'New arrivals'
      break

    default:
      path = gender === 'female' ? 'perfumes' : 'colognes'
      bestsellersTitle = `Best selling ${gender === 'female' ? 'perfumes' : 'colognes'}`
      newArrivalsTitle = 'New arrivals'
      break
  }

  return (
    <Section>
      <Link className={s.category} to={`/best-selling-${path}`}>{bestsellersTitle}</Link>
      <Link className={s.category} to={`/new-arrivals-${path}`}>{newArrivalsTitle}</Link>
    </Section>
  )
}

export default SEOCategoryLinks
